const constants = {
  nonStickyModules: ['shop-canada-compare-cards', 'shop-canada-hub', 'shop-mexico-compare-cards', 'shop-mexico-hub'],
};

export default constants;
